import {VehicleModelConsts} from '../../../../consts/vehicle-model.consts';
import {EventEmitter, Injectable} from '@angular/core';
import {VehicleModelStateInterface} from '../../../api/sections-api/vehicle-model-state.interface';
import {CalculationStorageService} from '../../../../../shared/services/calculation-storage.service';
import {InfoExpertLink4DictionaryItem, VehicleService, VehicleVersionData} from './vehicle.service';
import {BehaviorSubject} from 'rxjs/Rx';
import {CalculationService} from '../../calculation.service';
import {VehicleDataModel} from '../../../../models/vehicle-data.model';
import {isNullOrUndefined} from 'util';
import {VehicleModelState} from '../../../../../shared/states/vehicle-model.state';
import {ApplicationStateService} from '../../../../../shared/services/application-state.service';
import {ApplicationStateStorageService} from '../../../../../shared/services/application-state-storage.service';
import {isNotNullOrUndefined} from 'codelyzer/util/isNotNullOrUndefined';
import {isArray, isKIOSKPOLIS, isPromise, onlineEvent, isNext} from '../../../../utils/utils';
import {Validator} from '../../../../../shared/models/validator.enum';
import {OlxValuesMappingService} from '../../olx-values-mapping.service';
import {ChipsListConfig, ChipValue} from '../../../../../shared/components/chips-list/chips-list.component';
import {AssetsService} from '../../../../../shared/services/assets.service';
import {UrlParamsService} from '../../url-params.service';
import {VehicleSourceConsts} from '../../../../consts/vehicle-source.consts';
import {ApplicationContextService} from '../../configuration/application-context.service';
import {DialogKey} from '../../../../../shared/components/dialogs/dialogs-configuration';
import {DialogService} from '../../../dialog.service';
import {ImagePreviewDialogComponent} from '../../../../../shared/components/dialogs/image-preview-dialog/image-preview-dialog.component';
import {CalculationIntegrationParameterName} from '../../../../models/calculation-data.model';
import {endOfYear} from '../../../../../shared/utils/time-utils';
import {QueryParamName} from '../../../../enums/query-param-name.enum';
import {FieldsVisibilityService} from '../../../fields-visibility.service';
import {DraftOfferApiService} from '../../draft-offer-api.service';

@Injectable()
export class VehicleModelStateService extends VehicleModelConsts implements VehicleModelStateInterface {

  isNext = isNext();

  chipsListConfig: ChipsListConfig = {
    chips: [
      {
        key: VehicleModelConsts.BRAND_CODE,
        icon: this.getFullIconPath('car.svg'),
        visible: this.fieldsVisibilityService.vehicleModelChipVisible
      },
      {
        key: VehicleModelConsts.PRODUCTION_YEAR,
        icon: this.getFullIconPath('calendar.svg'),
        visible: this.fieldsVisibilityService.vehicleModelChipVisible
      },
      {
        key: VehicleModelConsts.MODEL_CODE,
        icon: this.getFullIconPath(this.isNext ? 'car.svg' : 'sedan.svg'),
        visible: this.fieldsVisibilityService.vehicleModelChipVisible
      },
      {
        key: VehicleModelConsts.FUEL_CODE,
        icon: this.getFullIconPath('gas.svg'),
        visible: this.fieldsVisibilityService.vehicleModelChipVisible
      },
      {
        key: VehicleModelConsts.ENGINE_CAPACITY,
        icon: this.getFullIconPath('engine.svg'),
        visible: this.fieldsVisibilityService.vehicleModelChipVisible
      },
      {
        key: VehicleModelConsts.TRANSMISSION,
        icon: this.getFullIconPath('shifter.svg'),
        visible: this.fieldsVisibilityService.vehicleModelChipVisible
      },
      {
        key: VehicleModelConsts.ENGINE_POWER,
        icon: this.getFullIconPath(this.isNext ? 'engine.svg' : 'engine-2.svg'),
        visible: this.fieldsVisibilityService.vehicleModelChipVisible
      },
      {
        key: VehicleModelConsts.VEHICLE_CODE_EUROTAX,
        icon: this.getFullIconPath(this.isNext ? 'car.svg' : 'suv.svg')
      },
      {
        key: VehicleModelConsts.VEHICLE_CODE_INFOEKSPERT,
        icon: this.getFullIconPath(this.isNext ? 'car.svg' : 'suv.svg'),
        visible: this.fieldsVisibilityService.vehicleModelChipVisible
      }
    ]
  };
  customerAgreementScanningMode: boolean = false;

  public registrationNumberEvent: EventEmitter<string> = new EventEmitter();
  public vinChangeEvent: EventEmitter<string> = new EventEmitter();
  public versionsUpdateEvent: EventEmitter<any> = new EventEmitter();
  public validateVersionEvent: EventEmitter<any> = new EventEmitter();
  public productionYearChangeEvent: EventEmitter<number> = new EventEmitter();
  public retriedDictionaryRequestEvent: EventEmitter<string> = new EventEmitter();
  public updateControlValueEvent: EventEmitter<{ key: string, value: any }> = new EventEmitter();
  public clearVehicleDataEvent: EventEmitter<void> = new EventEmitter();
  public vehicleCodeInfoExpertLink4Dictionary: any[];

  public fieldsWithCodeParam = [
    VehicleModelConsts.BRAND_CODE,
    VehicleModelConsts.MODEL_CODE,
    VehicleModelConsts.FUEL_CODE
  ];

  initializedCacheDict = new BehaviorSubject(null);
  clearCalculationUsed = false;

  chipsValues: ChipValue[];
  chipsVisible: boolean = false;
  readonly MIN_EUROTAX_VERSIONS_TO_SHOW_ENGINE_POWER = 9;
  readonly AVERAGE_VEHICLE_AGE = 15;

  private readonly EUROTAX_VERSION_KEY = 'EUROTAX';
  private readonly INFOEXPERT_LINK4_VERSION_KEY = 'INFOEXPERT_LINK4';
  private readonly UNKNOWN_REGISTRATION_NUMBER_VALUE = 'BRAK';

  private failedDictionaryRequestKey: string;
  private registrationNumber: string;
  private activeFieldKey: string;

  private eurotaxVersionData: any;
  private infoekspertLink4VersionData: any;

  constructor(private logicService: CalculationService,
              private calculationStorageService: CalculationStorageService,
              private applicationStateService: ApplicationStateService,
              private assetsService: AssetsService,
              private dialogService: DialogService,
              private urlParamsService: UrlParamsService,
              private contextService: ApplicationContextService,
              private applicationStorageService: ApplicationStateStorageService,
              private olxValuesMappingService: OlxValuesMappingService,
              private vehicleService: VehicleService,
              private fieldsVisibilityService: FieldsVisibilityService,
              private draftOfferApiService: DraftOfferApiService) {
    super();
    this.init();
  }

  get config() {
    return this.vehicleService.config;
  }

  get fieldsOrder(): string[] {
    return this.vehicleService.fieldsOrder;
  }

  get vehicleData(): VehicleDataModel {
    return this.logicService.vehicleData;
  }

  get vehicleModelState(): VehicleModelState {
    return this.vehicleService.state;
  }

  get unknownRegistrationNumber(): boolean {
    return this.applicationStateService.state.unknownRegistrationNumber;
  }

  get unknownRegistrationNumberValue(): string {
    return this.UNKNOWN_REGISTRATION_NUMBER_VALUE;
  }

  get isRegistrationNumberUnknown(): boolean {
    return this.vehicleData.registrationNumber === this.unknownRegistrationNumberValue;
  }

  get anyFirstStepDataFilled(): boolean {
    if (this.logicService.calculationData && this.logicService.vehicleData && this.logicService.insuranceData) {
      return this.logicService.firstStepCalculationData.map(fieldValue => isNotNullOrUndefined(fieldValue)).some(fieldWithValue => fieldWithValue);
    }
    return false;
  }

  get isLoggedUserIdParam(): boolean {
    return this.urlParamsService.isLoggedUserIdParam;
  }

  get isDiagnosticStationContext(): boolean {
    return this.contextService.isDiagnosticStationContext;
  }

  get aztecScannedFromQrCode(): boolean {
    return this.applicationStateService.state.aztecScannedFromQrCode;
  }

  get customerAgreementPhotoCompletedActionInfoVisible(): boolean {
    return isKIOSKPOLIS() && !this.customerAgreementScanningMode && !this.applicationStateService.aztecScannerActive && isNotNullOrUndefined(this.customerAgreementPhoto);
  }

  get scanClientAgreementButtonVisible(): boolean {
    return isKIOSKPOLIS() && this.isDiagnosticStationContext && !this.applicationStateService.aztecScannerActive && this.aztecScannedFromQrCode &&
        !this.customerAgreementScanningMode && !this.customerAgreementPhotoCompletedActionInfoVisible;
  }

  get customerAgreementPhoto(): string {
    return this.logicService.getIntegrationParameterValue(CalculationIntegrationParameterName.CUSTOMER_AGREEMENT_PHOTO);
  }

  init(): void {
    this.chipsListConfig.chips = this.chipsListConfig.chips.filter(config => config.visible || !isNotNullOrUndefined(config.visible));
    this.initializedCacheDict = new BehaviorSubject(null);
    // init dictionary for first field
    this.config[this.fieldsOrder[0]].dictionary = this.vehicleService.requestDictionary(this.fieldsOrder[0]).promise.then(items => {
      this.updateValueBasedOnUrlParameter(this.fieldsOrder[0], items);
      return items;
    });
    this.initCacheDict();
    onlineEvent.subscribe(() => this.retryFailedDictionaryRequest());
    this.vehicleService.stateUpdateEvent.subscribe(() => this.updateChipsValues());
  }

  valueChange(fieldKey: string, value: any) {
    this.handleInfoekspertVersionChange(fieldKey, value);
    this.vehicleData[fieldKey] = value;
    if (this.config[fieldKey].isStateParam) {
      this.applicationStorageService.updateApplicationState();
    }
    this.calculationStorageService.updateCalculation();

    this.handleBrandNameAndModelNameValue();

    if (this.fieldsWithCodeParam.includes(fieldKey)) {
      this.setParamInState(fieldKey, value);
    }

    if (fieldKey === VehicleModelConsts.VEHICLE_CODE_EUROTAX) {
      this.updateEnginePower(value);
    }

    this.productionYearChange(fieldKey, value);
    const fieldIndex = this.fieldsOrder.indexOf(fieldKey);
    if (fieldIndex < this.fieldsOrder.length - 1 && isNotNullOrUndefined(value)) {
      let nextFieldKey = this.fieldsOrder[fieldIndex + 1];

      this.config[nextFieldKey].dictionary = this.getDictionary(value, fieldKey, nextFieldKey);

      // separate vehicle versions requests
      // if (nextFieldKey === VehicleModelConsts.VEHICLE_CODE_EUROTAX) {
      //   nextFieldKey = VehicleModelConsts.VEHICLE_CODE_INFOEKSPERT;
      //   this.config[nextFieldKey].dictionary = this.getDictionary(value, fieldKey, nextFieldKey);
      // }
    }
  }

  changeEnginePower(value: string): void {
    this.vehicleModelState.enginePower = value;
    this.applicationStateService.state.enginePower = value;
    this.applicationStateService.updateApplicationState();

    this.updateChipsValues();
    if (isNotNullOrUndefined(value)) {
      this.setActiveFieldKey(VehicleModelConsts.VEHICLE_CODE_EUROTAX);
    }
  }

  updateEnginePower(eurotaxCode: string): void {
    if (isNotNullOrUndefined(eurotaxCode)) {
      const selectedItem = this.getEurotaxVersionItem(eurotaxCode);
      const enginePower = selectedItem ? selectedItem.horsepower : null;
      this.vehicleModelState.enginePower = enginePower;
      this.applicationStateService.state.enginePower = enginePower;
      this.applicationStateService.updateApplicationState();
    }
    this.updateChipsValues();
  }

  handleInfoekspertVersionChange(fieldKey: string, value: any): void {
    if (fieldKey === VehicleModelConsts.VEHICLE_CODE_INFOEKSPERT) {
      if (value !== this.vehicleData.vehicleCodeInfoekspert && isNotNullOrUndefined(value)) {
        this.vehicleService.requestInfoekspertLink4Dictionary(value).then((dictionary: InfoExpertLink4DictionaryItem[]) => {
          this.vehicleData.vehicleCodeInfoExpertLink4 = dictionary.length ? dictionary[0].code : undefined;
          this.vehicleCodeInfoExpertLink4Dictionary = dictionary;
          this.updateCalculation();
        });
        this.setActiveFieldKey(null);
      }
    }
    this.updateChipsValues();
  }

  registrationNumberChange(registrationNumber: string): void {
    if (this.unknownRegistrationNumber) {
      this.vehicleData.registrationNumber = this.UNKNOWN_REGISTRATION_NUMBER_VALUE;
    } else {
      this.vehicleData.registrationNumber = (registrationNumber && registrationNumber.length) ? registrationNumber : null;
    }
    this.calculationStorageService.updateCalculation();
  }

  initCacheDict() {
    let promisesArray = [];
    let isParamSetInVehicleDataModel = true;
    let fieldKey, nextFieldKey;

    for (let i = 0; i < this.fieldsOrder.length - 1; i++) {
      fieldKey = this.fieldsOrder[i];
      nextFieldKey = this.fieldsOrder[i + 1];

      if (this.config[fieldKey].isStateParam) {
        isParamSetInVehicleDataModel = isParamSetInVehicleDataModel && isNotNullOrUndefined(this.vehicleData[fieldKey]);
      } else {
        isParamSetInVehicleDataModel = isParamSetInVehicleDataModel && isNotNullOrUndefined(this.vehicleData[fieldKey]);
      }

      if (isParamSetInVehicleDataModel) {
        const result = this.vehicleService.requestDictionary(nextFieldKey);
        const promise = result.promise
          .then(items => this.handleItems(items, result.dictionaryKey))
          .catch(error => this.handleDictionaryRequestError(error, nextFieldKey));
        promisesArray.push(promise);

        // if (nextFieldKey === VehicleModelConsts.VEHICLE_CODE_EUROTAX) {
        //   const link4Result = this.vehicleService.requestDictionary(VehicleModelConsts.VEHICLE_CODE_INFOEKSPERT);
        //   const link4Promise = link4Result.promise
        //     .then(items => this.handleItems(items, link4Result.dictionaryKey))
        //     .catch(error => this.handleDictionaryRequestError(error, VehicleModelConsts.VEHICLE_CODE_INFOEKSPERT));
        //   promisesArray.push(link4Promise);
        // }
      }
    }

    Promise.all(promisesArray).then(() => {
      this.initializedCacheDict.next(true);
      this.vehicleService.initState(this.fieldsWithCodeParam);
      if (isNotNullOrUndefined(this.vehicleData.vehicleCodeEurotax)) {
        this.updateEnginePower(this.vehicleData.vehicleCodeEurotax);
      }
    });
  }

  isDictionaryFilled(fieldKey): boolean {
    const dictionary = this.config[fieldKey].dictionary;
    if (isNullOrUndefined(dictionary) || dictionary.length === 0) {
      return false;
    }
    return true;
  }

  updateApplicationState(): void {
    this.applicationStorageService.updateApplicationState();
  }

  updateCalculation(): void {
    this.calculationStorageService.updateCalculation();
  }

  resetFirstStepCalculationData(): void {
    this.logicService.resetFirstStepCalculationData();
    this.vehicleService.resetState();
    this.clearCalculationUsed = true;
  }

  handleRegistrationNumberChange(registrationNumber: string): void {
    const valueChanged = this.registrationNumber !== registrationNumber;
    if (isNotNullOrUndefined(registrationNumber) && valueChanged && this.draftOfferApiService.postDraftOfferAllowed) {
      this.draftOfferApiService.postDraftOffer();
    }
    this.registrationNumber = registrationNumber;
  }

  isFieldActive(fieldKey: string): boolean {
    return this.activeFieldKey === fieldKey;
  }

  setActiveFieldKey(key: string) {
    this.activeFieldKey = key;
  }

  requestVehicleVersionData(code: string, source: VehicleSourceConsts): Promise<VehicleVersionData> {
    return this.vehicleService.requestVehicleVersionData(code, source)
        .then(resp => {
          this.setVehicleVersionData(resp, source);
          this.updateStateWithVehicleVersionData(resp);
          this.updateChipsValues();

          return resp;
        });
  }

  initChipsValues(): void {
    this.chipsValues = [
      {
        key: VehicleModelConsts.BRAND_CODE,
        value: this.vehicleModelState ? this.vehicleModelState.brandName : null,
        visible: this.fieldsVisibilityService.vehicleModelChipVisible
      },
      {
        key: VehicleModelConsts.PRODUCTION_YEAR,
        value: this.vehicleData.productionYear,
        visible: this.fieldsVisibilityService.vehicleModelChipVisible
      },
      {
        key: VehicleModelConsts.MODEL_CODE,
        value: this.vehicleModelState ? this.vehicleModelState.modelName : null,
        visible: this.fieldsVisibilityService.vehicleModelChipVisible
      },
      {
        key: VehicleModelConsts.FUEL_CODE,
        value: this.vehicleModelState ? this.vehicleModelState.fuelName : null,
        visible: this.fieldsVisibilityService.vehicleModelChipVisible
      },
      {
        key: VehicleModelConsts.ENGINE_CAPACITY,
        value: isNotNullOrUndefined(this.vehicleData.engineCapacity) ? `${this.vehicleData.engineCapacity} cm3` : null,
        visible: this.fieldsVisibilityService.vehicleModelChipVisible
      },
      {
        key: VehicleModelConsts.ENGINE_POWER,
        value: this.vehicleModelState && this.vehicleModelState.enginePower ? `${this.vehicleModelState.enginePower}KM` : null,
        visible: this.fieldsVisibilityService.vehicleModelChipVisible
      },
      {
        key: VehicleModelConsts.VEHICLE_CODE_EUROTAX,
        value: this.getEurotaxVersionName(this.vehicleData.vehicleCodeEurotax),
        description: this.getEurotaxVersionDescription(this.vehicleData.vehicleCodeEurotax)
      }
    ];

    this.chipsValues = this.chipsValues.filter(chipValue => chipValue.visible || !isNotNullOrUndefined(chipValue.visible));

    if (this.urlParamsService.isLoggedUserIdParam) {
      const infoekspertVersionItem = this.vehicleData.vehicleCodeInfoekspert ? this.getInfoekspertVersionItem(this.vehicleData.vehicleCodeInfoekspert) : null;
      this.chipsValues.push({
        key: VehicleModelConsts.VEHICLE_CODE_INFOEKSPERT,
        value: infoekspertVersionItem ? infoekspertVersionItem.name : null,
        description: infoekspertVersionItem ? this.getInfoekspertVersionDescription(this.vehicleData.vehicleCodeInfoekspert) : null,
        visible: this.fieldsVisibilityService.vehicleModelChipVisible
      });
    }

    this.updateChipsVisible();
  }

  updateChipsValues(): void {
    this.updateChipValue(VehicleModelConsts.BRAND_CODE, this.vehicleModelState ? this.vehicleModelState.brandName : null);
    this.updateChipValue(VehicleModelConsts.PRODUCTION_YEAR, this.vehicleData.productionYear);
    this.updateChipValue(VehicleModelConsts.MODEL_CODE, this.vehicleModelState ? this.vehicleModelState.modelName : null);
    this.updateChipValue(VehicleModelConsts.FUEL_CODE, this.vehicleModelState ? this.vehicleModelState.fuelName : null);
    this.updateChipValue(VehicleModelConsts.ENGINE_CAPACITY, isNotNullOrUndefined(this.vehicleData.engineCapacity) ? `${this.vehicleData.engineCapacity} cm3` : null);
    this.updateChipValue(VehicleModelConsts.ENGINE_POWER, this.vehicleModelState && this.vehicleModelState.enginePower ? `${this.vehicleModelState.enginePower}KM` : null);
    this.updateChipValue(
        VehicleModelConsts.VEHICLE_CODE_EUROTAX,
        this.getEurotaxVersionName(this.vehicleData.vehicleCodeEurotax),
        this.getEurotaxVersionDescription(this.vehicleData.vehicleCodeEurotax)
    );

    if (this.urlParamsService.isLoggedUserIdParam) {
      const infoekspertVersionItem = this.vehicleData.vehicleCodeInfoekspert ? this.getInfoekspertVersionItem(this.vehicleData.vehicleCodeInfoekspert) : null;
      this.updateChipValue(
          VehicleModelConsts.VEHICLE_CODE_INFOEKSPERT,
          infoekspertVersionItem ? infoekspertVersionItem.name : null,
          infoekspertVersionItem ? this.getInfoekspertVersionDescription(this.vehicleData.vehicleCodeInfoekspert) : null
      );
    }

    this.updateChipsVisible();
  }

  saveCustomerAgreementPhoto(data: string): void {
    this.logicService.setCustomerAgreementPhoto(data);
  }

  openCustomerAgreementPhotoPreview(): void {
    this.dialogService.open(DialogKey.IMAGE_PREVIEW_DIALOG, ImagePreviewDialogComponent.getConfigBuilder().buildConfiguration({
      imageData: this.customerAgreementPhoto
    }));
  }

  private getEurotaxVersionName(code: string): string | null {
    if (code) {
      const dictionaryItem = this.getEurotaxVersionItem(this.vehicleData.vehicleCodeEurotax);
      if (isNotNullOrUndefined(dictionaryItem) && dictionaryItem.name) {
        return dictionaryItem.name;
      } else {
        return this.eurotaxVersionData ? this.eurotaxVersionData.name : null;
      }
    }
    return null;
  }

  private setVehicleVersionData(data: VehicleVersionData, source: VehicleSourceConsts): void {
    data = data ? data : null;
    switch (source) {
      case VehicleSourceConsts.EUROTAX: {
        this.eurotaxVersionData = data;
        break;
      }
      case VehicleSourceConsts.INFOEXPERT_LINK4: {
        this.infoekspertLink4VersionData = data;
        break;
      }
    }
  }

  private updateStateWithVehicleVersionData(data: VehicleVersionData): void {
    if (this.vehicleModelState) {
      if (!isNotNullOrUndefined(this.vehicleModelState.brandName) && data.brandName) {
        this.vehicleModelState.brandName = data.brandName;
      }
      if (!isNotNullOrUndefined(this.vehicleModelState.modelName) && data.modelName) {
        this.vehicleModelState.modelName = data.modelName;
      }
      if (!isNotNullOrUndefined(this.vehicleModelState.fuelName) && data.fuelName) {
        this.vehicleModelState.fuelName = data.fuelName;
      }
    }
  }

  private updateChipsVisible() {
    this.chipsVisible = this.chipsValues ? this.chipsValues.map(chipValue => chipValue.value).some(value => isNotNullOrUndefined(value)) : false;
  }

  private updateChipValue(key: string, value: any, description?: string) {
    if (this.chipsValues && !!this.chipsValues.find(chipValue => chipValue.key === key)) {
      this.chipsValues.find(chipValue => chipValue.key === key).value = value;
      if (description) {
        this.chipsValues.find(chipValue => chipValue.key === key).description = description;
      }
    }
  }

  private getEurotaxVersionDescription(code: string): string {
    const item = this.getEurotaxVersionItem(code);
    if (isNotNullOrUndefined(item)) {
      return `(${item.kilowatts} kW (${item.horsepower} KM) / ${item.numberOfDoors} drzwi / ${item.bodyType})`;
    } else if (isNotNullOrUndefined(this.eurotaxVersionData)) {
      let description = `(${this.eurotaxVersionData.powerKw} kW`;
      if (this.eurotaxVersionData.horsepower) {
        description += ` (${this.eurotaxVersionData.horsepower} KM)`;
      }
      description += ` / ${this.eurotaxVersionData.numberOfDoors} drzwi`;
      description += this.eurotaxVersionData.bodyType ? ` / ${this.eurotaxVersionData.bodyType})` : ')';
      return description;
    }
    return null;
  }

  private getInfoekspertVersionDescription(code: string): string {
    const item = this.getInfoekspertVersionItem(code);
    if (isNotNullOrUndefined(item)) {
      return `(${item.kilowatts} kW (${item.horsepower} KM) / ${item.numberOfDoors} drzwi / ${item.transmission} / ${item.bodyType})`;
    }
    return null;
  }

  private getEurotaxVersionItem(code: string): any {
    if (isArray(this.config[VehicleModelConsts.VEHICLE_CODE_EUROTAX].dictionary)) {
      return this.config[VehicleModelConsts.VEHICLE_CODE_EUROTAX].dictionary.find(item => item.code === code);
    }
    return null;
  }

  private getInfoekspertVersionItem(code: string): any {
    if (isArray(this.config[VehicleModelConsts.VEHICLE_CODE_INFOEKSPERT].dictionary)) {
      return this.config[VehicleModelConsts.VEHICLE_CODE_INFOEKSPERT].dictionary.find(item => item.code === code);
    }
    return null;
  }

  private handleBrandNameAndModelNameValue() {
    if (this.vehicleData.brandCode) {
      Promise.resolve(this.config[VehicleModelConsts.BRAND_CODE].dictionary)
        .then(value => {
            const values = value.filter(({brandCode}) => brandCode === this.vehicleData.brandCode);
            if (values.length) {
              this.vehicleData.brandName = values[0].brandName;
              this.applicationStorageService.updateApplicationState();
            }
          }
        );
    }

    if (this.vehicleData.modelCode) {
      Promise.resolve(this.config[VehicleModelConsts.MODEL_CODE].dictionary)
        .then(value => {
          const filteredValue = value.filter(({modelCode}) => modelCode === this.vehicleData.modelCode);
          this.vehicleData.modelName = filteredValue.length > 0 ? filteredValue[0].modelName : null;
          this.applicationStorageService.updateApplicationState();
        });
    }
  }

  private subscribeToRegistrationNumberChange(): void {
    this.registrationNumberEvent.subscribe(value => {
      // request for vehicle versions if previous params were chosen
      let lastFieldBeforeVersionsValue;
      if (this.config[this.vehicleService.lastFieldBeforeVersions].isStateParam) {
        lastFieldBeforeVersionsValue = this.vehicleData[this.vehicleService.lastFieldBeforeVersions];
      } else {
        lastFieldBeforeVersionsValue = this.vehicleData[this.vehicleService.lastFieldBeforeVersions];
      }
      if (!isNullOrUndefined(lastFieldBeforeVersionsValue)) {
        this.config[VehicleModelConsts.VEHICLE_CODE_INFOEKSPERT].dictionary = this.vehicleService
          .requestDictionary(VehicleModelConsts.VEHICLE_CODE_INFOEKSPERT)
          .promise
          .then(items => {
            items = this.handleItems(items, VehicleModelConsts.VEHICLE_CODE_INFOEKSPERT);
            this.versionsUpdateEvent.emit();
            this.vehicleService.updateCollectedCarsAmount(VehicleModelConsts.VEHICLE_CODE_INFOEKSPERT);
            return items;
          })
          .catch(error => this.handleDictionaryRequestError(error, VehicleModelConsts.VEHICLE_CODE_INFOEKSPERT));
      }
    });
  }

  private productionYearChange(fieldKey, value) {
    if (fieldKey === VehicleModelConsts.BRAND_CODE || fieldKey === VehicleModelConsts.PRODUCTION_YEAR) {
      this.productionYearChangeEvent.emit(value);
    }
  }

  /**
   * method sets name value (using code value) for appropriate field in vehicle model state
   */
  private setParamInState(fieldKey: string, code: string): void {
    let dictionary = this.config[fieldKey].dictionary;

    if (isArray(dictionary)) { // dictionary is an array
      this.setNameForCodeParam(dictionary, fieldKey, code);
    } else if (isPromise(dictionary)) { // dictionary is a promise
      dictionary.then(items => {
        this.setNameForCodeParam(items, fieldKey, code);
      });
    }
  }

  private setNameForCodeParam(items: any[], fieldKey: string, paramCode: string) {
    const { codeParam, nameParam } = this.vehicleService.getCodeDictionaryDetails(fieldKey);
    let names = items.filter(item => item[codeParam] === paramCode);
    let name = names.length ? names[0][nameParam] : null;
    this.vehicleModelState[nameParam] = name;
    this.updateChipsValues();
  }

  private isResponseVersionType(resp: any): boolean {
    return !isArray(resp);
  }

  private getItemsForVersion(resp: any, respKey: string): any[] {
    if (resp && resp.hasOwnProperty(respKey)) {
      const items = resp[respKey] ? resp[respKey] : [];
      return items;
    }
    return [];
  }

  private getCurrentValueFromModel(fieldKey: string): any {
    return this.config[fieldKey].isStateParam ? this.vehicleData[fieldKey] : this.vehicleData[fieldKey];
  }

  private retryFailedDictionaryRequest(): void {
    if (isNotNullOrUndefined(this.failedDictionaryRequestKey)) {
      const nextFieldKey = this.failedDictionaryRequestKey;
      this.config[nextFieldKey].dictionary = this.vehicleService
        .requestDictionary(nextFieldKey)
        .promise
        .then(items => this.handleItems(items, nextFieldKey));
    }
  }

  /**
   *
   * method version for one request for EUROTAX & IE_LINK4 versions
   */
  // private handleItems(items: any[], nextFieldKey: string): any {
  //   if (this.isResponseVersionType(items)) { // vehicles versions response
  //     const eurotaxVersions = this.getItemsForVersion(items, this.EUROTAX_VERSION_KEY);
  //     this.config[VehicleModelConsts.VEHICLE_CODE_EUROTAX].dictionary = eurotaxVersions;
  //     this.config[VehicleModelConsts.VEHICLE_CODE_INFOEKSPERT].dictionary = this.getItemsForVersion(items, this.INFOEXPERT_LINK4_VERSION_KEY);
  //     items = eurotaxVersions;
  //     this.vehicleService.forceExactCollectedCarsAmount = true;
  //   } else {
  //     this.config[nextFieldKey].dictionary = items;
  //   }
  //   this.vehicleService.updateCollectedCarsAmount(nextFieldKey);
  //   if (isNotNullOrUndefined(this.failedDictionaryRequestKey)) {
  //     this.retriedDictionaryRequestEvent.emit(nextFieldKey);
  //     this.failedDictionaryRequestKey = null;
  //   }
  //   return items;
  // }

  private handleItems(items: any[], nextFieldKey: string): any {
    this.updateValueBasedOnUrlParameter(nextFieldKey, items);
    if (this.isResponseVersionType(items)) { // vehicles versions response
      switch (nextFieldKey) {
        case VehicleModelConsts.VEHICLE_CODE_EUROTAX:
          items = this.getItemsForVersion(items, this.EUROTAX_VERSION_KEY);
          this.config[VehicleModelConsts.VEHICLE_CODE_EUROTAX].dictionary = items;
          this.validateVersionEvent.emit(VehicleModelConsts.VEHICLE_CODE_EUROTAX);
          break;
        case VehicleModelConsts.VEHICLE_CODE_INFOEKSPERT:
          items = this.getItemsForVersion(items, this.INFOEXPERT_LINK4_VERSION_KEY);
          this.config[VehicleModelConsts.VEHICLE_CODE_INFOEKSPERT].dictionary = items;
          this.validateVersionEvent.emit(VehicleModelConsts.VEHICLE_CODE_INFOEKSPERT);
          break;
      }
      this.vehicleService.forceExactCollectedCarsAmount = true;
    } else {
      this.config[nextFieldKey].dictionary = items;
    }
    if (this.config[nextFieldKey].isVersionField) {
      this.validateVersionEvent.emit(nextFieldKey);
    }
    this.vehicleService.updateCollectedCarsAmount(nextFieldKey);
    if (isNotNullOrUndefined(this.failedDictionaryRequestKey)) {
      this.retriedDictionaryRequestEvent.emit(nextFieldKey);
      this.failedDictionaryRequestKey = null;
    }
    return items;
  }

  private handleDictionaryRequestError(error: any, fieldKey: string): void {
    if (error._status === 0) {
      this.failedDictionaryRequestKey = fieldKey;
    }
  }

  private getDictionary(value: any, fieldKey: string, nextFieldKey: string): Promise<any> {
    return this.vehicleService
      .requestDictionary(nextFieldKey)
      .promise
      .then(items => {
        /**
         * fix for dictionaries update delay when internet connection is slow;
         * value that caused dictionary request is compared to current value from model;
         * dictionary from promise is up-to-date if these values are equal
         */
        if (value === this.getCurrentValueFromModel(fieldKey)) {
          return this.handleItems(items, nextFieldKey);
        }
      })
      .catch(error => this.handleDictionaryRequestError(error, nextFieldKey));
  }

  private getFullIconPath(filename: string): string {
    return `${this.assetsService.getVehicleChooserIconsDirectoryPath()}/${filename}`;
  }

  private updateValueBasedOnUrlParameter(fieldKey: string, items: any[]): void {
    switch (fieldKey) {
      case VehicleModelConsts.BRAND_CODE: {
        let brandItem;
        if (this.logicService.supportedCalculationUrlParams.includes(QueryParamName.MAKE)) {
          const olxBrandName = this.applicationStateService.state.queryParams[QueryParamName.MAKE];
          const brandName = this.olxValuesMappingService.mapBrandName(olxBrandName);
          brandItem = (olxBrandName && brandName) ? items.find(item => item.brandName.toUpperCase() === brandName.toUpperCase()) : null;
        }
        if (!isNotNullOrUndefined(brandItem) && this.logicService.supportedCalculationUrlParams.includes(QueryParamName.BRAND_NAME)) {
          const brandName = this.applicationStateService.state.queryParams[QueryParamName.BRAND_NAME];
          brandItem = brandName ? items.find(item => item.brandName.toUpperCase() === brandName.toUpperCase()) : null;
        }
        if (isNotNullOrUndefined(brandItem)) {
          this.updateControlValueEvent.emit({key: VehicleModelConsts.BRAND_CODE, value: brandItem.brandCode});
          this.logicService.markUrlCalculationParamInsterted();
        }
        break;
      }
      case VehicleModelConsts.PRODUCTION_YEAR: {
        if (this.logicService.supportedCalculationUrlParams.includes(QueryParamName.YEAR)) {
          const productionYearNumber = parseInt(this.applicationStateService.state.queryParams[QueryParamName.YEAR]);
          const productionYear = endOfYear(productionYearNumber);
          if (!isNaN(productionYearNumber) && items.includes(productionYearNumber)) {
            this.updateControlValueEvent.emit({key: VehicleModelConsts.PRODUCTION_YEAR, value: productionYear});
            this.logicService.markUrlCalculationParamInsterted();
          }
        }
        break;
      }
      case VehicleModelConsts.FUEL_CODE: {
        if (this.logicService.supportedCalculationUrlParams.includes(QueryParamName.FUEL) && items.length > 1) {
          const olxFuelName = this.applicationStateService.state.queryParams[QueryParamName.FUEL];
          const fuelName = this.olxValuesMappingService.mapFuelName(olxFuelName, items);
          const fuelItem = (olxFuelName && fuelName) ? items.find(item => item.fuelName.toUpperCase() === fuelName.toUpperCase()) : null;
          if (isNotNullOrUndefined(fuelItem)) {
            this.updateControlValueEvent.emit({key: VehicleModelConsts.FUEL_CODE, value: fuelItem.fuelCode});
            this.logicService.markUrlCalculationParamInsterted();
          }
        }
        break;
      }
    }
  }
}

export interface CodeDictionaryDetails {
  codeParam: string;
  nameParam: string;
}
